import { api } from '../../services/api'
const state = () => ({ items: [], loading: false, error: null })
const getters = { all: (s) => s.items }
const mutations = {
  SET_ITEMS(state, items) { state.items = items },
  ADD_ITEM(state, item) { state.items.unshift(item) },
  UPDATE_ITEM(state, item) {
    const i = state.items.findIndex(x => String(x.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) { state.items = state.items.filter(x => String(x.id) !== String(id)) },
  SET_LOADING(state, v) { state.loading = v },
  SET_ERROR(state, e) { state.error = e }
}
const actions = {
  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get('admin/hero-section')
      commit('SET_ITEMS', Array.isArray(data) ? data : (data?.items || []))
      commit('SET_ERROR', null)
    } catch (e) { commit('SET_ERROR', e.message || 'Failed to load') }
    finally { commit('SET_LOADING', false) }
  },
  async create({ commit }, payload) {
    const form = new FormData()
    if (payload.title) form.append('title', payload.title)
    if (payload.description) form.append('description', payload.description)
    if (payload.imageFile) form.append('image', payload.imageFile)
    const { data } = await api.post('admin/hero-section', form)
    commit('ADD_ITEM', data)
    return data
  },
  async update({ commit }, { id, payload }) {
    const form = new FormData()
    if (payload.title) form.append('title', payload.title)
    if (payload.description) form.append('description', payload.description)
    // Only send a file when user picked a new one; backend keeps old filename otherwise
    if (payload.imageFile) form.append('image', payload.imageFile)
    const { data } = await api.put(`admin/hero-section/${id}`, form)
    commit('UPDATE_ITEM', data)
    return data
  },
  async remove({ commit }, id) { await api.delete(`admin/hero-section/${id}`); commit('REMOVE_ITEM', id) }
}
export default { namespaced: true, state, getters, mutations, actions }
